import { useState } from "react";
import { toast } from "sonner";

const DEFAULT = {
  company: "Demo uzņēmums SIA", regNr: "40000000001", pvnNr: "LV40000000001",
  legalAddress: "Demo iela 2, Demo pilsēta, LV-0000", bank: "Demo Banka AS", iban: "LV00DEMO0000000000001",
  contact: "Demo Vārds Uzvārds", email: "iepirkumi@demouznemums.lv", phone: "+371 20 000 001",
};

const Field = ({ label, name, form, setForm, testId }) => (
  <label className="block">
    <span className="text-sm font-semibold mb-1 block">{label}</span>
    <input value={form[name]} onChange={(e) => setForm({ ...form, [name]: e.target.value })} data-testid={testId}
      className="w-full h-10 px-3 border border-[#E2E2E2] text-sm focus:outline-none focus:ring-2 focus:ring-[#111111]" />
  </label>
);

export default function AccProfile() {
  const [form, setForm] = useState(() => {
    try { return { ...DEFAULT, ...(JSON.parse(localStorage.getItem("demo_profile")) || {}) }; } catch { return DEFAULT; }
  });
  const save = (e) => {
    e.preventDefault();
    localStorage.setItem("demo_profile", JSON.stringify(form));
    toast.success("Rekvizīti saglabāti", { description: "Izmaiņas tiks izmantotas nākamajos rēķinos." });
  };
  return (
    <form onSubmit={save} className="space-y-5" data-testid="account-profile">
      <h2 className="text-xl font-extrabold uppercase">Uzņēmuma rekvizīti</h2>
      <div className="border border-[#E2E2E2] p-5 grid sm:grid-cols-2 gap-4">
        <Field label="Uzņēmuma nosaukums" name="company" form={form} setForm={setForm} testId="profile-company" />
        <Field label="Reģistrācijas nr." name="regNr" form={form} setForm={setForm} testId="profile-regnr" />
        <Field label="PVN nr." name="pvnNr" form={form} setForm={setForm} testId="profile-pvnnr" />
        <Field label="Juridiskā adrese" name="legalAddress" form={form} setForm={setForm} testId="profile-address" />
        <Field label="Banka" name="bank" form={form} setForm={setForm} testId="profile-bank" />
        <Field label="IBAN konts" name="iban" form={form} setForm={setForm} testId="profile-iban" />
      </div>
      <h3 className="text-sm font-bold uppercase tracking-widest">Kontaktpersona</h3>
      <div className="border border-[#E2E2E2] p-5 grid sm:grid-cols-3 gap-4">
        <Field label="Vārds, uzvārds" name="contact" form={form} setForm={setForm} testId="profile-contact" />
        <Field label="E-pasts" name="email" form={form} setForm={setForm} testId="profile-email" />
        <Field label="Tālrunis" name="phone" form={form} setForm={setForm} testId="profile-phone" />
      </div>
      <button type="submit" data-testid="profile-save" className="bg-[#D0121A] hover:bg-[#A80D14] text-white font-bold px-8 py-3 transition-colors">Saglabāt rekvizītus</button>
    </form>
  );
}
